import { render, staticRenderFns } from "./BotonDirectoProperties.vue?vue&type=template&id=5ab96d6c"
import script from "./BotonDirectoProperties.vue?vue&type=script&lang=js"
export * from "./BotonDirectoProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports